import selectPatientComponent from "./CustomPatientSelect";

export default {
  selectPatientComponent
};
